/** Синтетический workspace публичного демо. Не пересекается со staff storeId. */
export const DEMO_WORKSPACE = Object.freeze({
  login: 'demo',
  accountId: 'demo',
  storeId: 'demo',
});

export const DEMO_STORE_ID = DEMO_WORKSPACE.storeId;
